import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fab, fas);

export default function Footer() {
  return (
    <div className="text-center">
      <footer id="footer">
        <div className="container-fluid">
          <div className="social-icons mt-4">
            <a
              href="https://www.shecodes.io/graduates/63416-daria-mikita"
              target="_blank"
              rel="noopener noreferrer"
              className="link-danger fs-5"
            >
              <FontAwesomeIcon
                icon="fa-solid fa-code"
                className="socialmedia p-2"
              />
            </a>
            <a
              href="https://github.com/nauticalstars/my-online-portfolio"
              target="_blank"
              rel="noopener noreferrer"
              className="link-danger fs-5"
            >
              <FontAwesomeIcon
                icon="fa-brands fa-github-alt"
                className="socialmedia p-2"
              />
            </a>
            <a
              href="http://www.linkedin.com/in/daria-mikita"
              target="_blank"
              rel="noopener noreferrer"
              className="link-danger fs-5"
            >
              <FontAwesomeIcon
                icon="fa-brands fa-linkedin"
                className="socialmedia p-2"
              />
            </a>
          </div>
          <small>Coded by Daria Mikita</small>
        </div>
      </footer>
    </div>
  );
}
